import { Box, Typography } from '@material-ui/core';
import {
  AssignmentTurnedInOutlined,
  PlayCircleFilledWhiteOutlined,
  QueryBuilderOutlined,
  Subject
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CourseCard = ({ data, info }) => {
  const classes = useStyles();
  const { t } = useTranslation(['views', 'button', 'cards']);

  return (
    <Box className={classes.root}>
      <Box className={classes.card}>
        <Typography className={classes.price}>
          {
            "CERTIFICADO AUTÊNTICO 🔒"
          }
        </Typography>
        <Box className={classes.buttonBox}>
          <Typography className={classes.contentTitle}>
            {t('views:CourseRegistration.all_course_content')}:
          </Typography>
          <Box className={classes.contentBox} display="flex">
            <Box>
              <PlayCircleFilledWhiteOutlined fontSize="small" />
            </Box>
            <Box>
              <Typography component="span" className={classes.contentNumber}>
                {info?.count_videos ?? 0}{' '}
                {t('views:CourseRegistration.total_course_videos')}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.contentBox} display="flex">
            <Box>
              <Subject fontSize="small" />
            </Box>
            <Box>
              <Typography component="span" className={classes.contentNumber}>
                {info?.count_texts ?? 0}{' '}
                {t('views:CourseRegistration.total_course_texts')}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.contentBox} display="flex">
            <Box>
              <AssignmentTurnedInOutlined fontSize="small" />
            </Box>
            <Box>
              <Typography component="span" className={classes.contentNumber}>
                {info?.count_exams ?? 0}{' '}
                {t('views:CourseRegistration.total_course_exams')}
              </Typography>
            </Box>
          </Box>
          <Box className={classes.contentBox} display="flex">
            <Box>
              <QueryBuilderOutlined fontSize="small" />
            </Box>
            <Box>
              <Typography component="span" className={classes.contentNumber}>
                {info?.workload ?? 0}{' '}
                {t('views:CourseRegistration.total_course_workload')}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(6),

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  card: {
    padding: theme.spacing(2),
    backgroundColor: '#f4f6f8',
    boxShadow: '0 8px 16px 0 rgb(0 0 0 / 20%)',
    borderRadius: 8,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 350,
      padding: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      marginLeft: -38
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 350,
      MarginLeft: '70%'
    },
  },
  price: {
    fontSize: '18px',
    lineHeight: '100%',
  },
  cardPrice: {
    fontSize: 'small',
  },
  buttonBox: {
    paddingTop: theme.spacing(2),
  },
  contentTitle: {
    fontSize: 'large',
    fontWeight: 700,
  },
  contentNumber: { paddingLeft: theme.spacing(1) },
  contentBox: {
    paddingTop: theme.spacing(1),
  },
}));

export default CourseCard;
